<template>
    <span v-if="mostrarBtnAprovar">
        <b-button
            variant="primary"
            @click.stop="selecionarEvento()"
            v-if="mostrarBtnAprovar"
        >
            <span> <i class="fa fa-link"></i> Associar Evento </span>
        </b-button>
        <b-modal id="modalEvento" v-model="mostrarModal">
            <div slot="modal-title">Entrega - Associar Evento</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row class="mb-3">
                <b-col sm="12">
                    <b-form-checkbox
                        v-model="eventoEspecial"
                        :value="true"
                        :unchecked-value="false"
                    >
                        Evento Especial
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row v-if="!eventoEspecial">
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Código do Evento</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="codEvento"
                                :state="$v.codEvento.$error ? false : null"
                                @input="$v.codEvento.$touch()"
                                v-mask="'####################'"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarEvento()"
                                    title="Clique para pesquisar o Evento"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback
                                >O código do evento é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!eventoEspecial">
                <b-col sm="12">
                    <!-- {{ evento }} -->
                    <div v-if="evento">
                        <h5 class="heading-1">
                            <span>DADOS DO EVENTO NO SAS</span>
                        </h5>
                        <app-k-v
                            titulo="Código do Evento"
                            :md="4"
                            :lg="3"
                            :xl="3"
                            :dado="evento.eventoId"
                        ></app-k-v>
                        <app-k-v
                            titulo="Nome"
                            :md="4"
                            :lg="3"
                            :xl="3"
                            :dado="evento.nome"
                        ></app-k-v>
                        <app-k-v
                            titulo="Carga Horária"
                            :md="4"
                            :lg="3"
                            :xl="3"
                            :dado="evento.cargaHoraria"
                        ></app-k-v>
                        <app-k-v
                            titulo="Responsável"
                            :md="4"
                            :lg="3"
                            :xl="3"
                            :dado="evento.nomeResponsavel"
                        ></app-k-v>
                        <app-k-v
                            titulo="Data Inicial"
                            :md="4"
                            :lg="3"
                            :xl="3"
                            :dado="$maskDateTime(evento.periodoInicial)"
                        ></app-k-v>
                        <app-k-v
                            titulo="Data Final"
                            :md="4"
                            :lg="3"
                            :xl="3"
                            :dado="$maskDateTime(evento.periodoFinal)"
                        ></app-k-v>
                        <app-k-v titulo="Status" :md="4" :lg="3" :xl="3">
                            <app-status :status="evento.situacao"></app-status>
                        </app-k-v>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="eventoEspecial">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharEvento()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="evento == null || evento.eventoId != codEvento"
                    @click.stop="confirmarEvento()"
                    class="ml-2"
                    v-if="!eventoEspecial"
                >
                    <span> <i class="fa fa-link"></i> Associar Evento </span>
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="$v.justificativa.$invalid"
                    @click.stop="confirmarEventoEspecial()"
                    class="ml-2"
                    v-if="eventoEspecial"
                >
                    <span> <i class="fa fa-check-circle-o"></i> Aprovar</span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            codEvento: '',
            erros: [],
            mostrarModal: false,
            evento: null,
            justificativa: null,
            eventoEspecial: false
        }
    },

    methods: {
        selecionarEvento() {
            this.mostrarModal = true
        },

        fecharEvento() {
            this.mostrarModal = false
            this.codEvento = ''
            this.evento = null
        },

        confirmarEvento() {
            this.$swal({
                title: 'Associar Evento',
                html: `Confirma a associação do evento ${this.codEvento} a entrega?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarEvento()
                }
            })
        },

        confirmarEventoEspecial() {
            this.$swal({
                title: 'Evento Especial',
                html: `Confirma que a entrega é um evento especial?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovarEventoEspecial()
                }
            })
        },

        associarEvento() {
            this.$store.dispatch('addRequest')
            let entregaEventoDto = {
                entregaId: this.$route.params.entregaId,
                eventoId: this.codEvento
            }
            this.entregasServicos
                .associarEvento(entregaEventoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.erros = response.errors
                            // this.$toast.error(
                            // 	'Erro ao atualizar entrega!!!',
                            // 	'ERROR',
                            // 	this.$toastConfig.error
                            // )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        aprovarEventoEspecial() {
            this.$store.dispatch('addRequest')
            let entregaEventoDto = {
                entregaId: this.$route.params.entregaId,
                justificativa: this.justificativa
            }
            this.entregasServicos
                .aprovarEventoEspecial(entregaEventoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.erros = response.errors
                            // this.$toast.error(
                            // 	'Erro ao atualizar entrega!!!',
                            // 	'ERROR',
                            // 	this.$toastConfig.error
                            // )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        pesquisarEvento() {
            this.$store.dispatch('addRequest')
            this.entregasServicos
                .pesquisarEvento(this.$route.params.entregaId, this.codEvento)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.evento = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao pesquisar evento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAprovar() {
            let retorno =
                this.$temAcesso('CRED-GEST-ENTR-01') &&
                this.entrega.status === 1 &&
                !this.entrega.codEvento &&
                this.entrega.natureza == 'INSTRUTORIA' &&
                this.entrega.statusIdRm === 1
            return retorno
        }
    },

    validations: {
        codEvento: {
            required
        },

        justificativa: {
            justificativaOk() {
                if (this.eventoEspecial) {
                    if (this.justificativa) {
                        return this.justificativa.trim() !== ''
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            }
        }
    }
}
</script>
